<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <div>
            <v-row v-show="custom_filter.dataRange[0] !== '' && custom_filter.dataRange[1] !== '' && custom_filter.dataRange[0] !== null && custom_filter.dataRange[1] !== null">
                <v-col class="col-12 mb-2 mt-2 text-center">
                    <h3 class="title-date">{{ getDates }}</h3>
                </v-col>
            </v-row>
        </div>
        <v-layout class="mt-5">
            <v-btn class="transition button-icon" color="primary" rounded @click="filter_open = !filter_open">
                <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                Filtrar por:
                <v-icon :class="{ rotate90: filter_open }" small>chevron_right</v-icon>
            </v-btn>
        </v-layout>
        <collapse-transition>
            <m-form ref="filter" class="mt-8" v-show="filter_open">
                <v-row>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <DateRange v-model="filter.dataRange" @filter="filtrar()"
                                   :shortcut="true" label="Data consulta motor" />
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <DynamicSelect label="Usuário: "
                                       placeholder="Selecione os Usuários"
                                       v-model="filter.user"
                                       endpoint="/dynamic-selects/usuarios/login"
                        />
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <Autocomplete class="mb-6" label="Perfil Comercial:" :items="perfil_comercial" item-text="showText" item-value="perfil_comercial" v-model="filter.perfil_comercial" placeholder="Selecione os Perfis Comerciais" multiple hide-details :close-button-on-left="true" />
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <Autocomplete class="mb-6" label="Marca:" :items="flavors" item-text="showText" item-value="id" v-model="filter.flavors" placeholder="Selecione as Marcas" multiple hide-details :close-button-on-left="true" />
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <Autocomplete class="mb-6" label="Ponto de Venda:" :items="pontos_venda" item-text="showText" item-value="cod_ponto_venda" v-model="filter.ponto_venda" placeholder="Selecione os Pontos de Venda" multiple hide-details :close-button-on-left="true" />
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <Autocomplete class="mb-6" label="Comissionado:" :items="comissionados" v-model="filter.comissionado" item-text="showText" item-value="cod_comissionado" placeholder="Selecione os Comissionados" multiple hide-details :close-button-on-left="true" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <DateRange v-model="filter.dataRangeConsultaCredita" @filter="filtrar()" :shortcut="true" label="Data consulta credita" />
                    </v-col>
                    <v-col cols="12" sm="12" md="6" xl="6">
                        <DateRange v-model="filter.dataRangeRetornoCredita" @filter="filtrar()" :shortcut="true" label="Data retorno credita" />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <m-text-field label="Nome do Bem: "
                                      outlined
                                      v-model="filter.nome_bem"
                        />
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" sm="6" md="4">
                        <MoneyTextField outlined label="Valor unitário da parcela mínima:" v-model="filter.valor_parcela[0]" maxlength="12" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MoneyTextField outlined label="Valor unitário da parcela máxima:" v-model="filter.valor_parcela[1]" maxlength="12" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <MoneyTextField outlined label="Valor unitário do Bem Mínimo:" v-model="filter.valor_unitario_bem[0]" maxlength="12" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MoneyTextField outlined label="Valor unitário do Bem Máximo:" v-model="filter.valor_unitario_bem[1]" maxlength="12" />
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field label="Nº da Proposta: " id="FieldProposta" v-model="filter.id_documento" v-mask="'###########'" outlined />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <m-text-field v-mask="cpfCnpjMask"
                                      :rules="[$rules.cpf_cnpj]"
                                      label="CPF/CNPJ: "
                                      outlined
                                      v-model="filter.documento_cliente"
                                      v-uppercase />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <m-text-field label="Nome:" id="FieldNome" maxlength="150" outlined v-model="filter.nome_cliente" v-uppercase />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <DateField label="Data de Nascimento/Fundação: " id="FieldDataNascimento" :rules="[$rules.date]" v-model="filter.data_nascimento" max="today" />
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" sm="6" md="3">
                        <MoneyTextField outlined label="Valor da renda inicial:" v-model="filter.valor_renda[0]" maxlength="12" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <MoneyTextField outlined label="Valor da renda final:" v-model="filter.valor_renda[1]" maxlength="12" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <m-text-field label="CEP:" id="FieldCep" ref="cep" v-model="filter.cep" v-mask="'#####-###'" outlined />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select label="Situação de crédito:" item-value="value" item-text="label" :items="situacoes" clearable placeholder="Selecione a situação de crédito" v-model="filter.situacao_credito" outlined />
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" sm="6" md="3">
                        <v-select label="Defendeu Dados:" :items="defendeuDadosOptions" clearable v-model="filter.defendeu_dados" placeholder="Selecione a defesa" outlined />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select label="Dados Pendenciados" v-model="filter.dados_pendenciados" :items="pendenciasOptions" clearable outlined placeholder="Selecione os dados pendenciados" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select label="Grande Negócio:" :items="grandesNegociosOptions" clearable v-model="filter.grande_negocio" placeholder="Selecione o grande negócio" outlined />
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" sm="6" md="3">
                        <v-select label="Tipo do Grupo:" item-value="value" item-text="label" placeholder="Selecione o Tipo do Grupo" :items="tipos_grupos" clearable v-model="filter.tipo_grupo" outlined />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select label="Ramo Atividade:" item-value="value" item-text="showText" placeholder="Selecione o Ramo Atividade" hide-details :items="ramos_atividade" clearable v-model="filter.ramo_atividade" outlined />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <Autocomplete label="Profissão:" id="FieldProfissao" url="/profissao/autocomplete" :items="profissoes" v-input-filter="[$filters.textnumeric]" v-model="filter.profissao" item-text="nome" item-value="nome" placeholder="Selecione uma Profissão" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select label="Tipo de Plano:" item-value="value" item-text="label" placeholder="Selecione o Tipo de Plano" :items="tipos_de_plano" clearable v-model="filter.tipo_plano" outlined />
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col class="pa-5" cols="12" sm="6" md="3">
                        <v-select label="Origem aprovação:" item-value="value" item-text="name" placeholder="Selecione a origem de aprovação" hide-details :items="ApprovalOrigins" clearable v-model="filter.origem_aprovacao" outlined />
                    </v-col>
                    <v-col class="pa-5" cols="12" sm="6" md="3">
                        <v-select label="Status avaliação esteira crédito:" item-value="status_avaliacao_credita" item-text="showText" placeholder="Selecione o status avaliação esteira crédito" hide-details :items="status_avaliacao_esteira_credito" clearable v-model="filter.status_avaliacao_credita" outlined />
                    </v-col>
                    <v-col class="pa-5" cols="12" sm="6" md="3">
                        <v-select label="Status da venda" item-text="name" item-value="value" placeholder="Selecione o status da venda" :items="getStatusPedidosFormatados(filterData.status_vendas)" hide-details clearable v-model="filter.status_venda" outlined />
                    </v-col>
                    <v-col class="pa-5" cols="12" sm="6" md="3">
                        <label>Convertido em Venda?</label>
                        <v-radio-group v-model="filter.convertida_venda" row>
                            <v-radio label="Sim" value="S"></v-radio>
                            <v-radio label="Não" value="N"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col class="pa-5" cols="12" sm="6" md="3">
                        <v-select label="Motor Consultado" :items="motores" item-value="value" item-text="text" clearable placeholder="Selecione o Motor Consultado" v-model="filter.motor_consultado" outlined />
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" sm="6" md="3">
                        <MoneyTextField outlined label="Somarização de Cotas mínima:" v-model="filter.somarizacao_cotas[0]" maxlength="12" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <MoneyTextField outlined label="Somarização de Cotas máxima:" v-model="filter.somarizacao_cotas[1]" maxlength="12" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <MoneyTextField outlined label="Somarização de Parcelas mínima:" v-model="filter.somarizacao_parcelas[0]" maxlength="12" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <MoneyTextField outlined label="Somarização de Parcelas máxima:" v-model="filter.somarizacao_parcelas[1]" maxlength="12" />
                    </v-col>
                </v-row>
                <v-row class="justify-center justify-sm-end">
                    <v-col cols="12" sm="3" class="mb-6 mb-sm-1">
                        <v-btn color="secondary" block @click="cleanFilter">
                            Limpar
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-btn color="primary" block @click="filtrar()">
                            Filtrar
                        </v-btn>
                    </v-col>
                </v-row>
            </m-form>
        </collapse-transition>
        <div class="container_alterar_visualizacao">
            <v-btn class="mr-4 mt-5 transition" color="primary" @click="downloadDetailedReport">SALVAR RELATÓRIO</v-btn>
            <v-btn color="primary" class="mr-4 mt-5" @click="aba_visualizacao_visivel = true"> <v-icon color="lightgray">visibility</v-icon> Alterar Visualização </v-btn>
            <v-btn color="primary" class="mt-5" @click="show_dialog_colunas_fixas = true"> <v-icon color="lightgray">mdi-pin</v-icon> Fixar colunas </v-btn>
        </div>

        <DataTable url="painel/listar/consultas-detalhadas/credito-analise" :params="params" :overflow-y-visible="true" :overflow-x-scroll-visible="true" table-container class="listagem table-consultas-detalhadas mt-3" ref="datatable_detalhada">
            <template v-slot:header="{ props: { headersComputed } }">
                <thead>
                    <tr class="header-line-fixed">
                        <th class="sticky-column-header" style="left:0px;width:100px;">Ações</th>
                        <template v-for="(coluna, index) in headersVisiveis">
                            <th v-bind:key="index" v-if="coluna.value != 'convertido_venda'" :class="getStickedHeadColumn(coluna.value)" :style="getFixedColumnStyle(coluna.value, index)">
                                {{ coluna.text }}
                            </th>
                            <th v-bind:key="-index" v-else :class="getStickedHeadColumn(coluna.value)" :style="'width:480px;min-width:480px;max-width:480px;'+getFixedColumnStyle(coluna.value, index)">
                                <table style="width: 480px;">
                                    <div class="d-flex justify-center">
                                        <span class="text-center ml-2 mt-2">Situação da venda</span>
                                    </div>
                                    <tr class="d-flex mt-2" style="justify-content:space-between;">
                                        <td class="flex sub-header text-center flex-basis-0">
                                            Status da venda
                                        </td>
                                        <td class="flex sub-header text-center flex-basis-0">
                                            Pago?
                                        </td>
                                        <td class="flex sub-header text-center flex-basis-0">
                                            Assinado?
                                        </td>
                                    </tr>
                                </table>
                            </th>
                        </template>
                    </tr>
                </thead>
            </template>

            <template v-slot:items="{item, index: rowIndex}">
                <td class="sticky-column" :style="`left:0px;width:100px;background-color:${getRowColorByIndex(rowIndex)};text-align:center;`">
                    <v-menu :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" class="btn-acoes" v-bind="attrs" v-on="on">
                                <v-icon>mdi-dots-horizontal</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item>
                                <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="showAtribuirStatusPendente(item)" @click="atribuirStatusPendente(item)">
                                <v-list-item-title>Atribuir status de biometria</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="showAutorizarVenda(item)" @click="autorizarNegarVenda(item.status_avaliacao_credita, item, 1)">
                                <v-list-item-title>Autorizar venda</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="showNegarVenda(item)" @click="autorizarNegarVenda(item.status_avaliacao_credita, item, 0)">
                                <v-list-item-title>Negar venda</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="showRefazerAnalise(item)" @click="refazerAnalise(item)">
                                <v-list-item-title>Refazer análise de crédito</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="openDialogOrPdf(item.codigo_operacao, item.uuid)">
                                <v-list-item-title>Visualizar PDF</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="showVisualizarMotivo(item)" @click="openHistoryReason(item.id_consulta)">
                                <v-list-item-title>Visualizar motivo</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="showPendenciarDados(item)" @click="pendenciarDados(item)">
                                <v-list-item-title>Pendenciar dados</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </td>
                <template v-for="(coluna, colIndex) in headersVisiveis">
                    <td v-bind:key="colIndex" v-if="coluna.value != 'convertido_venda'"
                        :title="['status_avaliacao_esteira_credito'].includes(coluna.value) && formaDataTable(coluna.value, item).text && formaDataTable(coluna.value, item).text !== '-' ? formaDataTable(coluna.value, item).text : undefined"
                        :class="`tail-break-text ${formaDataTable(coluna.value, item).class} ${getStickedColumn(coluna.value)}`"
                        :style="(getFixedColumnStyle(coluna.value, colIndex))+(`color: ${formaDataTable(coluna.value, item).color};background-color:${getRowColorByIndex(rowIndex)};`)">
                        {{ formaDataTable(coluna.value, item).text }}
                    </td>
                    <td v-bind:key="-colIndex" v-else :class="getStickedColumn(coluna.value)" :style="(getFixedColumnStyle(coluna.value, colIndex))+(`color: ${formaDataTable(coluna.value, item).color};background-color:${getRowColorByIndex(rowIndex)};`)">
                        <div class="d-flex center-icon" style="width: 97%">
                            <div v-html="getStatusVenda(item.status_pedido)" style="text-align: center;" class="sub-header flex flex-basis-0 mx-4">
                            </div>
                            <div class="sub-header flex text-center flex-basis-0 center-icon">
                                <v-icon :color="verifyIfPaidAndReturnInBool(item.status_pedido) ? 'success' : 'error'">{{ verifyIfPaidAndReturnInBool(item.status_pedido) ? "mdi-check" : "mdi-close" }}</v-icon>
                            </div>
                            <div class="sub-header flex text-center flex-basis-0 center-icon">
                                <v-icon :color="isSigned(item.status) ? 'success' : 'error'">{{ isSigned(item.status) ? "mdi-check" : "mdi-close" }}</v-icon>
                            </div>
                        </div>
                    </td>
                </template>
            </template>
        </DataTable>
        <TabDialog ref="TabDialog" title="Alterar Visualização" v-model="aba_visualizacao_visivel">
            <p class="text--dark my-4">Selecione abaixo as colunas que deseja visualizar na listagem:</p>
            <v-checkbox v-model="campos_alterar_visualizacao.data_consulta" label="Data/Hora Consulta Motor" />
            <v-checkbox v-model="campos_alterar_visualizacao.situacao" label="Situação de crédito" />
            <v-checkbox v-model="campos_alterar_visualizacao.convertido_venda" label="Situação da venda" />
            <v-checkbox v-model="campos_alterar_visualizacao.numero_proposta" label="Nº Proposta" />
            <v-checkbox v-model="campos_alterar_visualizacao.cpf_cnpj" label="CPF/CNPJ" />
            <v-checkbox v-model="campos_alterar_visualizacao.nome" label="Nome" />
            <v-checkbox v-model="campos_alterar_visualizacao.usuario" label="Usuário" />
            <v-checkbox v-model="campos_alterar_visualizacao.nome_amigavel" label="Marca" />
            <v-checkbox v-model="campos_alterar_visualizacao.perfil_comercial" label="Perfil Comercial" />
            <v-checkbox v-model="campos_alterar_visualizacao.ponto_venda" label="Ponto de Venda" />
            <v-checkbox v-model="campos_alterar_visualizacao.comissionado" label="Comissionado" />
            <v-checkbox v-model="campos_alterar_visualizacao.renda" label="Renda" />
            <v-checkbox v-model="campos_alterar_visualizacao.nome_bem" label="Nome do Bem" />
            <v-checkbox v-model="campos_alterar_visualizacao.dados_pendenciados" label="Dados Pendenciados" />
            <v-checkbox v-model="campos_alterar_visualizacao.defendeu_dados" label="Defendeu Dados?" />
            <v-checkbox v-model="campos_alterar_visualizacao.grande_negocio" label="Grande Negócio" />
            <v-checkbox v-model="campos_alterar_visualizacao.valor_parcela" label="Valor da Parcela" />
            <v-checkbox v-model="campos_alterar_visualizacao.tipo_grupo" label="Tipo do Grupo" />
            <v-checkbox v-model="campos_alterar_visualizacao.tipo_plano" label="Tipo de Plano" />
            <v-checkbox v-model="campos_alterar_visualizacao.data_nascimento" label="Data de Nascimento/Fundação" />
            <v-checkbox v-model="campos_alterar_visualizacao.cep" label="CEP" />
            <v-checkbox v-model="campos_alterar_visualizacao.ramo_atividade" label="Ramo Atividade" />
            <v-checkbox v-model="campos_alterar_visualizacao.profissao" label="Profissão" />
            <v-checkbox v-model="campos_alterar_visualizacao.origem_aprovacao" label="Origem aprovação" />
            <v-checkbox v-model="campos_alterar_visualizacao.status_avaliacao_esteira_credito" label="Status avaliação esteira crédito" />
            <v-checkbox v-model="campos_alterar_visualizacao.data_consulta_credita" label="Data consulta credita" />
            <v-checkbox v-model="campos_alterar_visualizacao.data_retorno_credita" label="Data retorno credita" />
            <v-checkbox v-model="campos_alterar_visualizacao.motor_consultado" label="Motor Consultado" />
            <v-checkbox v-model="campos_alterar_visualizacao.qtd_cotas" label="Quantidade de Cotas" />
            <v-checkbox v-model="campos_alterar_visualizacao.valor_unitario_bem" label="Valor unitário do Bem" />
            <v-checkbox v-model="campos_alterar_visualizacao.valor_unitario_parcela" label="Valor unitário das Parcelas" />
            <v-checkbox v-model="campos_alterar_visualizacao.valor_total_bem" label="Valor total do Bem" />
            <v-checkbox v-model="campos_alterar_visualizacao.valor_total_parcela" label="Valor total das Parcelas" />
            <v-checkbox v-model="campos_alterar_visualizacao.somarizacao_cotas" label="Somarização de Cotas" />
            <v-checkbox v-model="campos_alterar_visualizacao.somarizacao_parcelas" label="Somarização de Parcelas" />
            <div slot="footer" class="d-flex row-padding">
                <v-flex class="col flex-basis-0">
                    <v-btn color="secondary" block @click="restaurarVisualizacao">Restaurar Configurações</v-btn>
                </v-flex>
                <v-flex class="col flex-basis-0">
                    <v-btn color="primary" block @click="aplicarAlteracoesVisualizacao">Aplicar</v-btn>
                </v-flex>
            </div>
        </TabDialog>
        <DialogConfirmChangeAutorization v-model="showConfirmChangeAutorization" :text="textConfirmChangeAutorization" :status-avaliacao-credita="status_avaliacao_credita" :consulta="consulta" :auth="auth" @reload="reloadDatatable" @decideSale="onDecideSale" />
        <DialogMudarParaPendente v-model="mostrarConfirmacaoParaPendente" :status-avaliacao-credita="status_avaliacao_credita" :consulta="consulta" @reload="reloadDatatable" />
        <DialogPendenciarDados v-model="showConfirmPendenciarDados" :consulta="consulta" :status-avaliacao-credita="status_avaliacao_credita" @reload="reloadDatatable" @confirmar="onPendenciarDados" />
        <DialogChoosePdf v-model="show_dialog_pdf" :codigos-operacao="codigosOperacao" :uuid-pdf="uuidPdf" @abrirPdf="openCreditAnalysisPdf" />
        <DialogPdf v-model="show_pdf" :base64="pdfBase64" />
        <DialogHistoryReasonAutorization v-model="showHistoryAuth" :historico="historico_motivo" />
        <DialogFixarColunas v-model="show_dialog_colunas_fixas" :table="tabelasColunasFixas.AnaliseCreditoConsultaDetalhada" :columns="headersToFixed" :already-fixed-columns="colunasFixas" @reload="reloadDatatableFromFixedColumns" />
    </v-container>
</template>

<script>
  import { alert, notification, sleep, verifyIfPaidAndReturnInBool, isSigned } from '../../../../plugins/helpers'
  import { mapState } from 'vuex'
  import { cpf, cnpj, toDateBR, toDateTimeBR, money, cep, formatMoneyOrDash } from '../../../../plugins/formatters'
  import { TiposGrupo, SituationAnalysisCredit, NivelPermissoesPerfil, TiposDePlano, CreditasAvaliationStatus, StatusPedidoDesc, PerfisAdmin, ApprovalOrigins as Origins, ApprovalOriginsDesc, SituationAnalysisCreditFormat, FiltroMotores } from '@/plugins/constants'
  import DialogConfirmChangeAutorization from '../consultation-reports-components/DialogConfirmChangeAutorization'
  import DialogHistoryReasonAutorization from '../consultation-reports-components/DialogHistoryReasonAutorization'
  import DialogChoosePdf from '@/dialogs/DialogChoosePdf'
  import DialogPdf from '@/dialogs/DialogPdf'
  import creditAnalysis from '@/mixins/creditAnalysis'
  import creditAnalysisVadu from '@/mixins/creditAnalysisVadu'
  import moment from 'moment'
  import * as Qs from 'qs'
  import DialogMudarParaPendente from './DialogMudarParaPendente.vue'
  import DialogFixarColunas from '@/dialogs/DialogFixarColunas'
  import { tabelasColunasFixas } from '@/plugins/constants/nomes_tabelas_colunas_fixas'
  import { AlertTypes } from '@/plugins/alerts_types'
  import { changeDataTableScrollSizeOnHoverByRef } from '@/plugins/scrollSize'
  import DialogPendenciarDados from './DialogPendenciarDados.vue'

  const TIME_IN_MS_TO_RELOAD_DATA_TABLE = 750

  export default {
    name: 'DetailedQueries',
    components: { DialogConfirmChangeAutorization, DialogMudarParaPendente, DialogChoosePdf, DialogPdf, DialogHistoryReasonAutorization, DialogFixarColunas, DialogPendenciarDados },
    mixins: [creditAnalysis, creditAnalysisVadu],
    props: {
      value: { type: Object }
    },
    data: () => ({
      tabelasColunasFixas,
      filter_open: false,
      show_dialog_pdf: false,
      pdfBase64: null,
      show_pdf: false,
      codigosOperacao: [],
      filterData: {
        status_vendas: []
      },
      uuidPdf: '',
      showHistoryAuth: false,
      show_dialog_colunas_fixas: false,
      headersToFixedCached: [],
      headersToFixed: [
        { value: 'data_consulta', text: 'Data/Hora Consulta Motor', width: 180 },
        { value: 'situacao', text: 'Situação de crédito', width: 150 },
        { value: 'convertido_venda', text: 'Situação da venda', width: 500 },
        { value: 'numero_proposta', text: 'Nº Proposta', width: 160 },
        { value: 'defendeu_dados', text: 'Defendeu Dados?', width: 150 },
        { value: 'grande_negocio', text: 'Grande Negócio', width: 150 },
        { value: 'dados_pendenciados', text: 'Dados Pendenciados', width: 200 },
        { value: 'cpf_cnpj', text: 'CPF/CNPJ', width: 190 },
        { value: 'nome', text: 'Nome', width: 300 },
        { value: 'usuario', text: 'Usuário', width: 400 },
        { value: 'nome_amigavel', text: 'Marca', width: 200 },
        { value: 'perfil_comercial', text: 'Perfil Comercial', width: 150 },
        { value: 'ponto_venda', text: 'Ponto de Venda', width: 190 },
        { value: 'comissionado', text: 'Comissionado', width: 190 },
        { value: 'renda', text: 'Renda', width: 150 },
        { value: 'nome_bem', text: 'Nome do Bem', width: 260 },
        { value: 'valor_parcela', text: 'Valor da Parcela', width: 150 },
        { value: 'tipo_grupo', text: 'Tipo do Grupo', width: 150 },
        { value: 'tipo_plano', text: 'Tipo de Plano', width: 150 },
        { value: 'data_nascimento', text: 'Data de Nascimento/Fundação', width: 210 },
        { value: 'cep', text: 'CEP', width: 150 },
        { value: 'ramo_atividade', text: 'Ramo Atividade', width: 150 },
        { value: 'profissao', text: 'Profissão', width: 350 },
        { value: 'origem_aprovacao', text: 'Origem aprovação', width: 150 },
        { value: 'status_avaliacao_esteira_credito', text: 'Status avaliação esteira crédito', width: 212 },
        { value: 'data_consulta_credita', text: 'Data consulta credita', width: 150 },
        { value: 'data_retorno_credita', text: 'Data retorno credita', width: 150 },
        { value: 'motor_consultado', text: 'Motor Consultado', width: 150 },
        { value: 'qtd_cotas', text: 'Quantidade de Cotas', width: 150 },
        { value: 'valor_unitario_bem', text: 'Valor unitário do Bem', width: 150 },
        { value: 'valor_unitario_parcela', text: 'Valor unitário das Parcelas', width: 180 },
        { value: 'valor_total_bem', text: 'Valor total do Bem', width: 150 },
        { value: 'valor_total_parcela', text: 'Valor total das Parcelas', width: 150 },
        { value: 'somarizacao_cotas', text: 'Somarização de Cotas', width: 180 },
        { value: 'somarizacao_parcelas', text: 'Somarização de Parcelas', width: 180 }
      ],
      headers: [
        { text: '', sortable: false },
        { text: 'Data/Hora Consulta Motor', value: 'data_consulta_motor' },
        { text: 'Situação de crédito', value: 'situacao' },
        { text: 'Origem Aprovação', value: 'origem_aprovacao' },
        { text: 'Status avaliação esteira crédito', value: 'status_avaliacao_credita' },
        { text: 'Defendeu dados?', value: 'defendeu_dados' },
        { text: 'Grande Negócio?', value: 'grande_negocio' },
        { text: 'Dados Pendenciados', value: 'dados_pendenciados' },
        { text: 'Data/Hora Consulta Credita', value: 'data_consulta_credita' },
        { text: 'Data/Hora Retorno Credita', value: 'data_retorno_credita' },
        { text: 'Status da venda', value: 'status_pedido' },
        { text: 'Pago', value: 'is_venda_paga' },
        { text: 'Assinado', value: 'is_assinado' },
        { text: 'Nº Proposta', value: 'id_documento' },
        { text: 'CPF/CNPJ', value: 'documento_cliente' },
        { text: 'Nome / Razão Social', value: 'nome_cliente' },
        { text: 'Usuário', value: 'login' },
        { text: 'Marca', value: 'nome_amigavel' },
        { text: 'Perfil Comercial', value: 'perfil_comercial' },
        { text: 'Ponto de Venda', value: 'cod_ponto_venda' },
        { text: 'Comissionado', value: 'cod_comissionado' },
        { text: 'Renda / Faturamento Médio', value: 'renda_cliente' },
        { text: 'Nome do Bem', value: 'nome_bem' },
        { text: 'Valor Parcela', value: 'vl_parcela' },
        { text: 'Tipo do Grupo', value: 'categoria_grupo' },
        { text: 'Tipo de Plano', value: 'tipo_plano' },
        { text: 'Data de Nascimento/Fundação', value: 'data_cliente' },
        { text: 'CEP', value: 'cep' },
        { text: 'Ramo Atividade', value: 'ramo_atividade' },
        { text: 'Profissão', value: 'profissao' },
        { text: 'Motor Consultado', value: 'motor_consultado' },
        { text: 'Qtd Cotas', value: 'qtd_cotas' },
        { text: 'Valor unitário do Bem', value: 'valor_unitario_bem' },
        { text: 'Valor unitário das Parcelas', value: 'valor_unitario_parcela' },
        { text: 'Valor total do Bem', value: 'valor_total_bem' },
        { text: 'Valor total das Parcelas', value: 'valor_total_parcela' },
        { text: 'Somarização de Cotas', value: 'somarizacao_cotas' },
        { text: 'Somarização de Parcelas', value: 'somarizacao_parcelas' }
      ],
      filter: {
        dataRange: ['', ''],
        dataRangeConsultaCredita: ['', ''],
        dataRangeRetornoCredita: ['', ''],
        user: [],
        ponto_venda: [],
        perfil_comercial: [],
        flavors: [],
        comissionado: [],
        numero_proposta: '',
        nome_bem: '',
        valor_parcela: [0, 0],
        valor_renda: [0, 0],
        documento_cliente: '',
        nome_cliente: '',
        data_nascimento: '',
        cep: '',
        tipo_grupo: '',
        tipo_plano: '',
        convertida_venda: '',
        situacao_credito: '',
        ramo_atividade: '',
        profissao: '',
        origem_aprovacao: '',
        status_avaliacao_credita: '',
        status_venda: '',
        motor_consultado: 0,
        qtd_cotas: '',
        valor_unitario_bem: [0, 0],
        valor_unitario_parcela: [0, 0],
        valor_total_bem: [0, 0],
        valor_total_parcela: [0, 0],
        somarizacao_cotas: [0, 0],
        somarizacao_parcelas: [0, 0],
        defendeu_dados: null,
        grande_negocio: null,
        dados_pendenciados: null
      },
      pontos_venda: [],
      comissionados: [],
      ramos_atividade: [],
      profissoes: [],
      perfil_comercial: [],
      flavors: [],
      custom_filter: {
        dataRange: ['', ''],
        dataRangeConsultaCredita: ['', ''],
        dataRangeRetornoCredita: ['', ''],
        user: [],
        ponto_venda: [],
        perfil_comercial: [],
        flavors: [],
        comissionado: [],
        numero_proposta: '',
        nome_bem: '',
        valor_parcela: [0, 0],
        valor_renda: [0, 0],
        documento_cliente: '',
        nome_cliente: '',
        data_nascimento: '',
        cep: '',
        tipo_grupo: '',
        tipo_plano: '',
        convertida_venda: '',
        situacao_credito: '',
        ramo_atividade: '',
        profissao: '',
        origem_aprovacao: '',
        status_avaliacao_credita: '',
        status_venda: '',
        qtd_cotas: '',
        valor_unitario_bem: [0, 0],
        valor_unitario_parcela: [0, 0],
        valor_total_bem: [0, 0],
        valor_total_parcela: [0, 0],
        somarizacao_cotas: [0, 0],
        somarizacao_parcelas: [0, 0],
        defendeu_dados: null,
        grande_negocio: null,
        dados_pendenciados: null
      },
      tipos_grupos: [TiposGrupo.GrupoPontual, TiposGrupo.GrupoConvencional, TiposGrupo.GrupoPraJa, 'Todos'],
      tipos_de_plano: [...TiposDePlano],
      situacoes: [{ value: SituationAnalysisCredit.APROVADO, label: 'Aprovada' }, { value: SituationAnalysisCredit.ANALISAR, label: SituationAnalysisCredit.ANALISAR }, { value: SituationAnalysisCredit.PENDENTE, label: SituationAnalysisCredit.PENDENTE }, { value: SituationAnalysisCredit.REPROVADO, label: 'Reprovada' }, { value: SituationAnalysisCredit.PENDENCIA_CADASTRAL, label: SituationAnalysisCredit.PENDENCIA_CADASTRAL }, { value: 'Todos', label: 'Todos' }],
      defendeuDadosOptions: [{ text: 'Sim', value: true }, { text: 'Não', value: false }],
      grandesNegociosOptions: [{ text: 'Sim', value: true }, { text: 'Não', value: false }],
      pendenciasOptions: [
        { text: 'Nome', value: 'pendencia_nome' },
        { text: 'Razão Social', value: 'pendencia_razao_social' },
        { text: 'E-mail', value: 'pendencia_email' },
        { text: 'Data de Nascimento', value: 'pendencia_data_nascimento' },
        { text: 'Data de Fundação', value: 'pendencia_dt_fundacao' }
      ],
      showConfirmChangeAutorization: false,
      textConfirmChangeAutorization: '',
      mostrarConfirmacaoParaPendente: false,
      showConfirmPendenciarDados: false,
      status_avaliacao_credita: '',
      consulta: '',
      auth: '',
      motores: [...FiltroMotores],
      campos_alterar_visualizacao: {
        data_consulta: true,
        situacao: true,
        convertido_venda: true,
        cpf_cnpj: true,
        nome: true,
        usuario: true,
        nome_amigavel: true,
        perfil_comercial: true,
        ponto_venda: true,
        comissionado: true,
        renda: true,
        numero_proposta: true,
        nome_bem: true,
        valor_parcela: true,
        tipo_grupo: true,
        tipo_plano: true,
        data_nascimento: true,
        cep: true,
        ramo_atividade: true,
        profissao: true,
        origem_aprovacao: true,
        status_avaliacao_esteira_credito: true,
        data_consulta_credita: true,
        data_retorno_credita: true,
        motor_consultado: true,
        qtd_cotas: true,
        valor_unitario_bem: true,
        valor_total_parcela: true,
        valor_total_bem: true,
        valor_unitario_parcela: true,
        somarizacao_cotas: true,
        somarizacao_parcelas: true,
        defendeu_dados: true,
        grande_negocio: true,
        dados_pendenciados: true
      },
      campos_usuario: {
        data_consulta: true,
        situacao: true,
        convertido_venda: true,
        cpf_cnpj: true,
        nome: true,
        usuario: true,
        nome_amigavel: true,
        perfil_comercial: true,
        ponto_venda: true,
        comissionado: true,
        renda: true,
        numero_proposta: true,
        nome_bem: true,
        valor_parcela: true,
        tipo_grupo: true,
        tipo_plano: true,
        data_nascimento: true,
        cep: true,
        ramo_atividade: true,
        profissao: true,
        origem_aprovacao: true,
        status_avaliacao_esteira_credito: true,
        data_consulta_credita: true,
        data_retorno_credita: true,
        motor_consultado: true,
        qtd_cotas: true,
        valor_unitario_bem: true,
        valor_total_parcela: true,
        valor_total_bem: true,
        valor_unitario_parcela: true,
        somarizacao_cotas: true,
        somarizacao_parcelas: true,
        defendeu_dados: true,
        grande_negocio: true,
        dados_pendenciados: true
      },
      aba_visualizacao_visivel: false,
      historico_motivo: [],
      colunasFixas: []
    }),
    computed: {
      ...mapState(['perfil_adm']),
      params () {
        return {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'id_consulta',
            descending: true
          },
          filters: this.custom_filter,
          id_usuario_interno: this.value.id_usuario > 0 ? this.value.id_usuario : ''
        }
      },
      getDates () {
        const format = 'YYYY-MM-DD'
        const data_inicial = moment(this.custom_filter.dataRange[0], format)
        const data_final = moment(this.custom_filter.dataRange[1], format)
        return `${data_inicial.format('DD/MM/YYYY')} a ${data_final.format('DD/MM/YYYY')}`
      },
      headersComputed () {
        return this.headers
      },
      ApprovalOrigins () {
        return Object.keys(Origins).map(value => ({ value: Origins[value], name: ApprovalOriginsDesc[Origins[value]] }))
      },
      headersVisiveis () {
        const campos = this.transformChangeVisualizationInHeaderValue({ ...this.campos_usuario })
        return this.headersToFixed.filter(h => !!campos[h.value])
      },
      cpfCnpjMask () {
        return {
          mask: ['SSS.SSS.SSS-SS', 'SS.SSS.SSS/SSSS-SS'],
          tokens: {
            'S': {
              pattern: /[A-Za-z0-9]/,
              transform: (char) => char.toUpperCase()
            }
          }
        }
      }
    },
    watch: {
      show_pdf (value) {
        if (!value) {
          this.pdfBase64 = null
        }
      },
      aba_visualizacao_visivel (show) {
        if (show) {
          Object.assign(this.campos_alterar_visualizacao, this.campos_usuario)
        }
      }
    },
    async mounted () {
      this.headersToFixedCached = this.headersToFixed
      const wrapper = this.$refs.datatable_detalhada?.$el?.querySelector('.v-data-table__wrapper')
      const container = this.$refs.datatable_detalhada?.$el
      changeDataTableScrollSizeOnHoverByRef(wrapper, container)
      this.loadFixedFields()
      await this.getStatusVendas()
      this.carregarCamposUsuario()
      await this.getFilters()
      this.setDataFilter()
    },
    methods: {
      getRowColorByIndex (index) {
        return (index % 2) === 0 ? 'var(--white)' : 'var(--darkwhite)'
      },
      getStickedColumn (value) {
        return this.colunasFixas.includes(value) ? 'sticky-column' : ''
      },
      getStickedHeadColumn (value) {
        return this.colunasFixas.includes(value) ? 'sticky-column-header' : ''
      },
      getFixedColumnStyle (value, index, headers = this.headersToFixed) {
        if (!this.colunasFixas.includes(value)) return ''
        let left = 100
        for (let i = 0; i < index; i++) {
          left += headers[i].width
        }
        const width = headers[index].width
        return `left:${left}px;width:${width}px;min-width:${width}px;max-width:${width}px;`
      },
      getStatusPedidosFormatados (pedidos) {
        const pedidosUnicos = new Map()

        pedidos.forEach(pedido => {
          const valor = StatusPedidoDesc[pedido.name] ?? pedido.name
          if (!pedidosUnicos.has(valor)) {
            pedidosUnicos.set(valor, { ...pedido, name: valor, value: valor })
          }
        })

        return Array.from(pedidosUnicos.values())
      },
      async getStatusVendas () {
        try {
          const response = await this.$http.get('/contrato/filtro/status_venda')
          this.filterData.status_vendas = response.data.status_vendas
        } catch (error) {
          notification('error', `Erro ao carregar o filtro de status do pedido, erro:\n` + error)
        }
      },
      formaDataTable (column, item) {
        const sticked = this.getStickedColumn(column.value)
        switch (column) {
          case 'data_consulta':
            return { class: 'text-center;' + sticked, text: item.data_consulta_motor || '-' | toDateTimeBR, color: 'black' }
          case 'situacao':
            return { class: sticked, text: this.getSituacao(item.situacao) || '-', color: this.getColorSituation(item.situacao) }
          case 'origem_aprovacao':
            return { class: 'text-center;' + sticked, text: this.formatApprovalOrigin(item.nome_origem) || '-', color: 'black' }
          case 'status_avaliacao_esteira_credito':
            return { class: 'text-center;' + sticked, text: item.status_avaliacao_credita || '-', color: 'black' }
          case 'data_consulta_credita':
            return { class: 'text-center;' + sticked, text: this.formatDateBr(item.data_consulta_credita), color: 'black' }
          case 'data_retorno_credita':
            return { class: 'text-center;' + sticked, text: this.formatDateBr(item.data_retorno_credita), color: 'black' }
          case 'numero_proposta':
            return { class: 'text-center;' + sticked, text: item.id_documento || '-', color: 'black' }
          case 'defendeu_dados':
            return {
              class: 'text-center;' + sticked,
              text: (item.defendeu_dados === true || item.defendeu_dados === 1) ? 'Sim' : (item.defendeu_dados === false || item.defendeu_dados === 0) ? 'Não' : '-',
              color: 'black'
            }
          case 'grande_negocio':
            return {
              class: 'text-center;' + sticked,
              text: (item.grande_negocio === true || item.grande_negocio === 1) ? 'Sim' : (item.grande_negocio === false || item.grande_negocio === 0) ? 'Não' : '-',
              color: 'black'
            }
          case 'dados_pendenciados':
            const pendencias = []
            if (item.pendencia_nome) pendencias.push('Nome')
            if (item.pendencia_razao_social) pendencias.push('Razão Social')
            if (item.pendencia_email) pendencias.push('E-mail')
            if (item.pendencia_data_nascimento) pendencias.push('Data de Nascimento')
            if (item.pendencia_dt_fundacao) pendencias.push('Data de Fundação')
            return { class: sticked,
                     text: pendencias.length ? pendencias.join(', ') : '-',
                     color: 'black' }
          case 'cpf_cnpj':
            return { class: sticked, text: this.maskCPFCNPJ(item) || '-', color: 'black' }
          case 'nome':
            return { class: 'text-center' + sticked, text: item.nome_cliente || '-', color: 'black' }
          case 'usuario':
            return { class: sticked, text: item.login + ' - ' + item.nome || '-', color: 'black' }
          case 'nome_amigavel':
            return { class: sticked, text: item.nome_amigavel || '-', color: 'black' }
          case 'perfil_comercial':
            return { class: sticked, text: item.perfil_comercial || '-', color: 'black' }
          case 'ponto_venda':
            return { class: sticked, text: item.cod_ponto_venda + ' - ' + item.nome_ponto_venda || '-', color: 'black' }
          case 'comissionado':
            return { class: sticked, text: item.cod_comissionado + ' - ' + item.nome_comissionado || '-', color: 'black' }
          case 'renda':
            return { class: sticked, text: item.renda_cliente ? money(item.renda_cliente) : '-', color: 'black' }
          case 'nome_bem':
            return { class: sticked, text: item.nome_bem || '-', color: 'black' }
          case 'valor_parcela':
            return { class: sticked, text: item.vl_parcela ? money(item.vl_parcela) : '-', color: 'black' }
          case 'tipo_grupo':
            return { class: sticked, text: item.categoria_grupo || '-', color: 'black' }
          case 'tipo_plano':
            return { class: 'text-center;' + sticked, text: item.tipo_plano || '-', color: 'black' }
          case 'data_nascimento':
            return { class: 'text-center;' + sticked, text: this.getCustomerDate(item), color: 'black' }
          case 'cep':
            return { class: sticked, text: item.cep || '-' | cep, color: 'black' }
          case 'ramo_atividade':
            return { class: sticked, text: item.ramo_atividade || '-', color: 'black' }
          case 'profissao':
            return { class: sticked, text: item.profissao || '-', color: 'black' }
          case 'motor_consultado':
            return { class: 'text-center;' + sticked, text: item.motor_consultado, color: 'black' }
          case 'qtd_cotas':
            return { class: 'text-center;' + sticked, text: item.qtd_cotas || '-', color: 'black' }
          case 'valor_unitario_bem':
            return { class: 'text-center;' + sticked, text: item.valor_unitario_bem ? money(item.valor_unitario_bem) : '-', color: 'black' }
          case 'valor_unitario_parcela':
            return { class: 'text-center;' + sticked, text: item.valor_unitario_parcela ? money(item.valor_unitario_parcela) : '-', color: 'black' }
          case 'valor_total_bem':
            return { class: 'text-center;' + sticked, text: item.valor_total_bem ? formatMoneyOrDash(item.valor_total_bem) : '-', color: 'black' }
          case 'valor_total_parcela':
            return { class: 'text-center;' + sticked, text: item.valor_total_parcela ? money(item.valor_total_parcela) : '-', color: 'black' }
          case 'somarizacao_cotas':
            return { class: 'text-center;' + sticked, text: item.somarizacao_cotas ? money(item.somarizacao_cotas) : '-', color: 'black' }
          case 'somarizacao_parcelas':
            return { class: 'text-center;' + sticked, text: item.somarizacao_parcelas ? money(item.somarizacao_parcelas) : '-', color: 'black' }
          default:
            return { class: 'text-center;' + sticked, text: '', color: 'black' }
        }
      },
      obterHeadersAtivos () {
        const campos_usuario = this.transformChangeVisualizationInHeaderValue(this.campos_usuario)
        return this.headersToFixed.filter((header) => {
          if (campos_usuario[header.value] !== undefined && !campos_usuario[header.value]) {
            return false
          }
          return true
        })
      },
      transformChangeVisualizationInHeaderValue (campos_usuario) {
        let campos = campos_usuario
        campos.data_consulta_motor = campos_usuario.data_consulta
        campos.status_pedido = campos_usuario.convertida_venda
        campos.is_venda_paga = campos_usuario.convertida_venda
        campos.is_assinado = campos_usuario.convertida_venda
        campos.documento_cliente = campos_usuario.cpf_cnpj
        campos.nome_cliente = campos_usuario.nome
        campos.login = campos_usuario.usuario
        campos.cod_ponto_venda = campos_usuario.ponto_venda
        campos.cod_comissionado = campos_usuario.comissionado
        campos.renda_cliente = campos_usuario.renda
        campos.id_documento = campos_usuario.numero_proposta
        campos.vl_parcela = campos_usuario.valor_parcela
        campos.categoria_grupo = campos_usuario.tipo_grupo
        campos.data_cliente = campos_usuario.data_nascimento
        campos.status_avaliacao_credita = campos_usuario.status_avaliacao_esteira_credito

        return campos
      },
      downloadDetailedReport () {
        const headersFiltrados = this.obterHeadersAtivos()
        const encoded_params = Qs.stringify({
          filters: this.custom_filter,
          headers: headersFiltrados.map(header => header.value),
          headers_formatado: headersFiltrados.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/credit-analysis/detailed-query/download?${encoded_params}`)
      },
      getCustomerDate (item) {
        return item.data_cliente ? toDateBR(item.data_cliente) : '-'
      },
      formatDateBr (val) {
        return val !== null ? toDateTimeBR(val) : '-'
      },
      async getFilters () {
        await this.$http
          .get('/painel/get-filters/credito-analise')
          .then(result => {
            if (result.data) {
              this.pontos_venda = result.data.pontos_venda
              this.comissionados = result.data.comissionados
              this.ramos_atividade = result.data.ramos_atividade
              this.status_avaliacao_esteira_credito = result.data.status_avaliacao_esteira_credito
              this.perfil_comercial = result.data.perfil_comercial
              this.flavors = result.data.flavors
            }
          })
          .catch(err => notification('error', err, 'Não foi possível buscar os filtros!'))
      },
      setDataFilter () {
        this.cleanFilter()
        this.filter.user = [this.value.login]
        this.filter.comissionado = [this.value.cod_comissionado]
        this.filter.ponto_venda = [this.value.cod_ponto_venda]
        this.filter.dataRange = [this.value.datas[0], this.value.datas[1]]
        this.filtrar()
      },
      maskCPFCNPJ (item) {
        return item.pessoa === 'fisica' ? cpf(item.cpf) : cnpj(item.cnpj)
      },
      getSituacao (situacao) {
        if (situacao === SituationAnalysisCredit.APROVADO) {
          return 'Aprovada'
        } else if (situacao === SituationAnalysisCredit.ANALISAR) {
          return SituationAnalysisCredit.ANALISAR
        } else if (situacao === SituationAnalysisCredit.REPROVADO) {
          return 'Reprovada'
        } else if (situacao === SituationAnalysisCredit.PENDENTE) {
          return SituationAnalysisCredit.PENDENTE
        } else if (situacao === SituationAnalysisCredit.PENDENCIA_CADASTRAL) {
          return SituationAnalysisCredit.PENDENCIA_CADASTRAL
        } else {
          return '-'
        }
      },
      filtrar () {
        this.custom_filter = null
        this.$nextTick(() => {
          this.custom_filter = { ...this.filter }
          this.reloadDatatable()
        })
      },
      cleanFilter () {
        this.filter = {
          dataRange: ['', ''],
          dataRangeConsultaCredita: ['', ''],
          dataRangeRetornoCredita: ['', ''],
          user: [],
          ponto_venda: [],
          comissionado: [],
          perfil_comercial: [],
          flavors: [],
          numero_proposta: '',
          valor_parcela: [0, 0],
          valor_renda: [0, 0],
          documento_cliente: '',
          nome_cliente: '',
          data_nascimento: '',
          cep: '',
          tipo_grupo: '',
          convertida_venda: '',
          origem_aprovacao: '',
          status_avaliacao_esteira_credito: '',
          status_venda: '',
          qtd_cotas: '',
          valor_unitario_bem: [0, 0],
          valor_unitario_parcela: [0, 0],
          valor_total_bem: [0, 0],
          valor_total_parcela: [0, 0],
          somarizacao_cotas: [0, 0],
          somarizacao_parcelas: [0, 0],
          defendeu_dados: null,
          grande_negocio: null,
          dados_pendenciados: null
        }

        this.$nextTick(() => {
          this.custom_filter = { ...this.filter }
          this.reloadDatatable()
        })
      },
      showAutorizarVenda (item) {
        if (this.isSuporte()) {
          return false
        }
        if (!this.isGerente() && !this.isAnalista()) {
          return false
        }
        if (item.motor_consultado === 'Vadu' && !this.hasVaduPermission) {
          return false
        }
        return (item.id_documento === '' || item.id_documento === null) && (this.isReprovadoAnaliseCredito(item.autorizacao_analise_cadastral_backoffice) || (item.situacao !== SituationAnalysisCredit.APROVADO && !this.isAprovadaAnaliseCredito(item.autorizacao_analise_cadastral_backoffice)))
      },
      showPendenciarDados (item) {
        if (this.isSuporte()) {
          return false
        }

        if (!this.isGerente() && !this.isAnalista()) {
          return false
        }
        return item.situacao === SituationAnalysisCredit.ANALISAR || item.situacao === SituationAnalysisCredit.REPROVADO
      },
      showAtribuirStatusPendente (item) {
        if (this.isSuporte()) {
          return false
        }
        return item.situacao === SituationAnalysisCredit.ANALISAR
      },
      showRefazerAnalise (item) {
        if (this.isSuporte()) {
          return false
        }
        if (this.isAprovadaAnaliseCredito(item.autorizacao_analise_cadastral_backoffice) || this.isReprovadoAnaliseCredito(item.autorizacao_analise_cadastral_backoffice)) {
          return false
        }
        return (item.id_documento === '' || item.id_documento === null) && (item.situacao === SituationAnalysisCredit.ANALISAR || item.situacao === SituationAnalysisCredit.PENDENTE) && (item.status_avaliacao_credita.toString().toLowerCase().trim() === CreditasAvaliationStatus.PENDENTE)
      },
      showNegarVenda (item) {
        if (this.isSuporte()) {
          return false
        }
        if (!this.isGerente() && !this.isAnalista()) {
          return false
        }
        if (item.motor_consultado === 'Vadu' && !this.hasVaduPermission) {
          return false
        }
        return (item.id_documento === '' || item.id_documento === null) &&
          (this.isAprovadaAnaliseCredito(item.autorizacao_analise_cadastral_backoffice) ||
            (item.situacao !== SituationAnalysisCredit.REPROVADO && !this.isReprovadoAnaliseCredito(item.autorizacao_analise_cadastral_backoffice)))
      },

      isSuporte () {
        return this.$session.get('permissao_perfil') === NivelPermissoesPerfil.Suporte.nome_banco
      },
      isGerente () {
        return this.$session.get('permissao_perfil') === NivelPermissoesPerfil.Gerente.nome_banco || (this.perfil_adm !== PerfisAdmin.Credito.id_banco && this.perfil_adm !== PerfisAdmin.Sem_Acesso.id_banco)
      },
      isAnalista () {
        return this.$session.get('permissao_perfil') === NivelPermissoesPerfil.Analista.nome_banco
      },
      analistaPodeEditar (item) {
        return (
          item.status_avaliacao_credita
            .toString()
            .toLowerCase()
            .trim() === CreditasAvaliationStatus.PENDENTE && (item.situacao === SituationAnalysisCredit.ANALISAR || item.situacao === SituationAnalysisCredit.PENDENTE)
        )
      },
      isAprovadaAnaliseCredito (decisaoBackoffice) {
        return decisaoBackoffice !== null && decisaoBackoffice !== undefined && decisaoBackoffice
      },
      isReprovadoAnaliseCredito (decisaoBackoffice) {
        return decisaoBackoffice !== null && decisaoBackoffice !== undefined && !decisaoBackoffice
      },
      openDialogOrPdf (codigos_operacao, uuid) {
        const codigos = JSON.parse(codigos_operacao)
        if (!uuid || !codigos) {
          notification('warning', 'Não é possível visualizar o PDF por falta de informações do Crivo.')
          return
        }
        if (codigos.length > 1) {
          this.openPdfDialog(codigos, uuid)
        } else {
          this.openCreditAnalysisPdf(codigos[0], uuid)
        }
      },
      openPdfDialog (codigos_operacao, uuid) {
        this.codigosOperacao = codigos_operacao
        this.uuidPdf = uuid
        this.show_dialog_pdf = true
      },
      openFixarColunasDialog () {
        this.show_dialog_colunas_fixas = true
      },
      aplicarOrdemDasColunas () {
        const fixas = this.headersToFixedCached.filter(
          col => this.colunasFixas.includes(col.value) && this.campos_usuario[col.value]
        )

        const restantes = this.headersToFixedCached.filter(
          col => !this.colunasFixas.includes(col.value) && this.campos_usuario[col.value]
        )

        this.headersToFixed = [...fixas, ...restantes]
        this.reloadDatatable()
      },
      async loadFixedFields () {
        await this.$http.get(`/painel/fixed/fields/lists?table=${tabelasColunasFixas.AnaliseCreditoConsultaDetalhada}`)
          .then(data => {
            data = data.data
            this.colunasFixas = []
            if (data.ok && (data.colunas?.length > 0)) {
              data.colunas.forEach(val => {
                this.colunasFixas.push(val.nome_campo)
              })
            } else {
              this.colunasFixas = [
                'data_consulta',
                'situacao',
                'origem_aprovacao'
              ]
            }
            this.aplicarOrdemDasColunas()
          }).catch(e => {
            this.colunasFixas = [
              'data_consulta',
              'situacao',
              'origem_aprovacao'
            ]
            this.aplicarOrdemDasColunas()
            notification(AlertTypes.WARN, 'Não foi possível, carregar as colunas fixas.')
          })
      },
      openCreditAnalysisPdf (codigo_operacao, uuid) {
        this.$http(`/painel/credit_analysis/get_pdf/${uuid}?codigo_operacao=${encodeURIComponent(codigo_operacao)}`)
          .then(response => {
            this.pdfBase64 = response.data
            this.show_pdf = true
          })
          .catch(() => {
            notification('warning', 'Falha ao obter o PDF da consulta.')
          })
      },
      async autorizarNegarVenda (status, consulta, action) {
        this.status_avaliacao_credita = status
          .toString()
          .toLowerCase()
          .trim()
        this.consulta = consulta
        this.auth = action
        this.textConfirmChangeAutorization = this.getTextConfirmChangeAuthorization(consulta)
        this.showConfirmChangeAutorization = true
      },
      pendenciarDados (consulta) {
        this.consulta = consulta
        this.showConfirmPendenciarDados = true
      },
      atribuirStatusPendente (consulta) {
        this.consulta = consulta
        this.mostrarConfirmacaoParaPendente = true
      },
      getTextConfirmChangeAuthorization (consulta) {
        const situacao = this.getSituacao(consulta.situacao)

        if (this.status_avaliacao_credita === CreditasAvaliationStatus.CONCLUIDO) {
          return 'A consulta selecionada já foi analisada e retornada pelo Sistema de Crédito. Deseja realmente alterar o status de autorização?'
        } else if (situacao === SituationAnalysisCreditFormat.REPROVADA) {
          return 'A consulta selecionada foi atribuída como reprovada pelo Sistema de Crédito. Deseja realmente alterar o status de autorização?'
        } else if (situacao === SituationAnalysisCreditFormat.APROVADA) {
          return 'A consulta selecionada foi atribuída como aprovada pelo Sistema de Crédito. Deseja realmente alterar o status de autorização?'
        } else {
          return 'Deseja realmente alterar o status de autorização?'
        }
      },
      async onDecideSale (consulta, decisao, motivo) {
        const situacaoAntiga = this.getSituacao(consulta.situacao)
        await this.decideSale(consulta, decisao, situacaoAntiga, motivo).then(() => {
          setTimeout(() => {
            this.reloadDatatable()
          }, TIME_IN_MS_TO_RELOAD_DATA_TABLE)
        })
      },
      async onPendenciarDados ({ motivo, dadosSelecionados }) {
        const campos = [
          'pendencia_nome',
          'pendencia_email',
          'pendencia_data_nascimento',
          'pendencia_dt_fundacao',
          'pendencia_razao_social'
        ]
        const pendencias = {}
        campos.forEach(campo => {
          pendencias[campo] = dadosSelecionados.includes(campo)
        })

        const situacaoAntiga = this.getSituacao(this.consulta.situacao)

        await this.pendenciarDadosAnalise({
          consulta: this.consulta,
          motivo,
          situacaoAntiga,
          pendencias
        })

        setTimeout(() => {
          this.reloadDatatable()
        }, TIME_IN_MS_TO_RELOAD_DATA_TABLE)
      },
      showVisualizarMotivo (item) {
        return item.exibir_motivo > 0
      },
      async refazerAnalise (item) {
        alert({
          text: 'A análise de crédito será refeita e pode ter seu resultado alterado. Deseja prosseguir?',
          buttons: {
            Fechar: () => {},
            Confirmar: async () => this.requestAnaliseCredito(item)
          }
        })
      },
      async requestAnaliseCredito (item) {
        await this.checkAnaliseCadastral(item.id_pedido, !!item.grupo_pontual, !!item.grupo_praja, item)
        await sleep(1)
        this.reloadDatatable()
      },
      getColorSituation (situacao) {
        switch (situacao) {
          case SituationAnalysisCredit.APROVADO:
            return '#1A984C'
          case SituationAnalysisCredit.REPROVADO:
            return '#DC222B'
          case SituationAnalysisCredit.ANALISAR:
            return '#FFB800'
          case SituationAnalysisCredit.PENDENTE:
            return '#E0542B'
          case SituationAnalysisCredit.PENDENCIA_CADASTRAL:
            return '#1E90FF'
        }
        return '#000000de'
      },
      getStatusVenda (status_pedido) {
        const text = StatusPedidoDesc[status_pedido] ?? status_pedido
        return this.formatText(text, 4)
      },
      formatText (text, wordsPerLine) {
        // Função para formatar o texto com quebra de linha por número de palavras
        return this.addLineBreaks(text, wordsPerLine)
      },
      addLineBreaks (text, wordsPerLine) {
        const words = text.split(' ')
        const lines = []
        for (let i = 0; i < words.length; i += wordsPerLine) {
          lines.push(words.slice(i, i + wordsPerLine).join(' '))
        }
        return lines.join('<br>')
      },
      isSigned (status_contrato) {
        return isSigned(status_contrato)
      },
      updateHeaders () {
        const fixedColumns = this.headersToFixedCached.filter(
          header => this.colunasFixas.includes(header.value) && this.campos_usuario[header.value]
        )

        const dynamicColumns = this.headersToFixedCached.filter(
          header => !this.colunasFixas.includes(header.value) && this.campos_usuario[header.value]
        )

        this.headersToFixed = [...fixedColumns, ...dynamicColumns]
      },
      async carregarCamposUsuario () {
        try {
          const res = await this.$http.get('/painel/credit_analysis/user_fields', { options: { silent: true } })
          Object.assign(this.campos_usuario, res.data)
        } catch (e) {
          notification('error', e, 'Não foi possível carregar a configuração de campos da tabela')
        }
      },
      aplicarAlteracoesVisualizacao () {
        Object.assign(this.campos_usuario, this.campos_alterar_visualizacao)
        this.updateHeaders()
        this.aba_visualizacao_visivel = false
        this.salvarConfiguracaoCampos()
        this.reloadDatatable()
      },
      restaurarVisualizacao () {
        Object.keys(this.campos_usuario).forEach(key => {
          this.campos_usuario[key] = true
          this.campos_alterar_visualizacao[key] = true
        })
        this.updateHeaders()
        this.aba_visualizacao_visivel = false
        this.salvarConfiguracaoCampos()
        this.reloadDatatable()
      },
      salvarConfiguracaoCampos () {
        this.$http.post('/painel/credit_analysis/user_fields', this.campos_usuario, { options: { silent: true } })
      },
      reloadDatatableFromFixedColumns () {
        this.loadFixedFields()
        this.$refs.datatable_detalhada.reload()
      },
      reloadDatatable () {
        this.$refs.datatable_detalhada.reload()
      },
      openHistoryReason (id_consulta) {
        this.$http
          .get(`/credit_analysis/history_reason/${id_consulta}`)
          .then(res => {
            this.historico_motivo = res.data
            this.showHistoryAuth = true
            this.reloadDatatable()
          })
          .catch(e => {
            notification('error', e, 'Não foi possível exibir os motivos.')
          })
      },
      verifyIfPaidAndReturnInBool (status) {
        return verifyIfPaidAndReturnInBool(status)
      },
      formatApprovalOrigin (status) {
        return ApprovalOriginsDesc[status]
      }
    }
  }
</script>

<style scoped lang="scss">

.sub-header {
    text-align: center;
    font-weight: normal;
}
.center-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.v-btn:not(.v-btn--round).v-size--default.btn-acoes {
    padding: 0;
    min-width: 0;
    width: 40px;
    height: 80%;
    margin-right: 10px;
}
.title-date {
    color: var(--primary);
    font-weight: 800;
}
.listagem th {
    min-width: 100px;
    white-space: nowrap;
}
.listagem th:nth-of-type(2) {
    min-width: auto;
    white-space: nowrap;
}

.listagem {
    overflow-x: auto;
    white-space: nowrap;

    $espacamento_scrollbar_vertical_top_tela_grande: 2.7rem;
    $espacamento_scrollbar_horizontal_responsiva: var(--marginScrollLeft);

    ::-webkit-scrollbar-track:vertical {
        margin-top: $espacamento_scrollbar_vertical_top_tela_grande;
    }
    @media (max-width: 1366px) {
        $espacamento_scrollbar_vertical_top_tela_media: 2.2rem;

        ::-webkit-scrollbar-track:vertical {
            margin-top: $espacamento_scrollbar_vertical_top_tela_media;
        }
    }
}
</style>

<style lang="scss">
.sticky-column-header {
    background-color: var(--darkwhite);
    position: sticky;
    z-index: 5 !important;
}
.sticky-column {
    position: sticky;
    z-index: 1 !important;
}

th, .sticky-column-header {
  text-align: center !important;
  /* Outras regras se quiser */
}
.background-white {
  background-color: var(--white);
}
.background-darkwhite {
  background-color: var(--darkwhite);
}
.container_alterar_visualizacao {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
}
.table-consultas-detalhadas .v-data-table__wrapper {
    max-height: 70vh;
}
.table-consultas-detalhadas .v-data-table__wrapper table thead tr {
    z-index: 2;
    position: sticky;
    background-color: var(--darkwhite);
    top: 0px;
}
.table-consultas-detalhadas .v-data-table__wrapper table tbody tr:nth-child(2n) {
    background-color: var(--darkwhite);
}
.table-consultas-detalhadas .v-data-table__wrapper table tbody tr:hover {
    background: var(--white) !important;
}
.table-consultas-detalhadas .v-data-table__wrapper table tbody tr:nth-child(2n):hover {
    background: var(--darkwhite) !important;
}

@media (max-width: 400px) {
    .button-icon {
        padding: 0px;
        width: 100%;
        overflow-wrap: break-word !important;
        white-space: normal !important;
        .v-icon:first-child {
            display: none;
        }
        span {
            overflow-wrap: break-word;
            width: 100%;
        }
    }
}

.tail-break-text {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
